export const Mdata = {
    "Arizona":{
        'change': 8.49,
        'population': 7453517,
    },
    "Apache County": {
        'change': -9.99,
        'population':64371,
    },
    "Cochise County": {
        'change': -5.84,
        'population':123677,
    },
    "Coconino County": {
        'change': 10.33,
        'population':148305,
    },
    "Gila County": {
        'change': -0.79,
        'population': 53176,
    },
    "Graham County": {
        'change': 4.58,
        'population':38926,
    },
    "Greenlee County": {
        'change': 17.36,
        'population': 9902,
    },
    "La Paz County": {
        'change': -24.95,
        'population': 15378,
    },
    "Maricopa County": {
        'change': 20.55,
        'population':4601603,
    },
    "Mohave County": {
        'change': 8.49,
        'population':217191,
    },
    "Navajo County": {
        'change': -0.89,
        'population':106498,
    },
    "Pima County": {
        'change': 8.38,
        'population':1062384,
    },
    "Pinal County": {
        'change': 17.12,
        'population':440111,
    },
    "Santa Cruz County": {
        'change': 0.68,
        'population': 47744,
    },
    "Yavapai County": {
        'change': 15.51,
        'population': 243763,
    },
    "Yuma County": {
        'change': 5.4,
        'population':206320, 
    },
};

